import { createSlice } from "@reduxjs/toolkit";
import { getTagsLookup } from "../services/tagsLookupService";

let initialState = {
  isLoading: false,
  data: [],
  pages: 0,
  errors: null
};

const tagsLookupSlice = createSlice({
  name: "tagsLookup",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getTagsLookup.pending, (state) => {
      state.isLoading = true;
      state.errors = null;
    })
    builder.addCase(getTagsLookup.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.data = (payload[0] && JSON.parse(payload[0].jsonData)) || [];
      state.errors = null;
    })
    builder.addCase(getTagsLookup.rejected, (state) => {
      state.isLoading = false;
      state.errors = [{ msg: "something went wrong!" }];
    })

  }
});

export default tagsLookupSlice.reducer;